import { render, staticRenderFns } from "./OmxTagInput.vue?vue&type=template&id=5867a20e&scoped=true"
import script from "./OmxTagInput.vue?vue&type=script&lang=js"
export * from "./OmxTagInput.vue?vue&type=script&lang=js"
import style0 from "./OmxTagInput.vue?vue&type=style&index=0&id=5867a20e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5867a20e",
  null
  
)

export default component.exports